import ExclamationMarkCircle from "../../components/ExclamationCircle";

const Dialog = ({ handleclose, headermessage, actionmessage }) => {
  return (
    <div className="flex justify-center items-center w-full h-full top-0 absolute bg-dialog">
      <div className="text-white w-[1120px] h-[506px] bg-grey-900">
        <div className="flex">
          <div className="mt-[54.4px] ml-[54.4px] h-[52px]">
            <ExclamationMarkCircle />
          </div>
          <div className="w-[1024px] h-[52px] mt-[52px] ml-[22.4px] mr-[341px] text-xl leading-[52px] font-scaniacondensed text-light-1">
            {headermessage}
          </div>
        </div>
        <div className="w-[1024px] h-[80px] mt-[34px] mx-[48px] font-scaniacondensed text-light-1 text-md leading-[40px]">
          {actionmessage}
        </div>
        <div className="flex w-full justify-center pt-[48px]">
          <button
            className="absolute rounded-[8px] w-[1024px] h-[120px] bg-grey-868 text-md font-scaniacondensed text-light-1"
            onClick={() => handleclose()}
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dialog;
